module.exports = __webpack_public_path__ + "img/客服.afb5f279.jpg";